import React from "react";
import "./Box.css";


const box = ({ title, content, images }) => {
  return (
    <>
      <div className="mt-3 sm:mt-5 md:mt-5 content-center">
    
          <div className=" flex md:flex-col sm:flex-col content-center ">
            <div>
            <img
              src={images} alt="image"
              className="h-[80px] w-[80px] sm:h-[90px] md:h-[100px] sm:w-[90px] md:w-[100px] shadow-xl mx-auto border rounded-full">
              
            </img>
            </div>
          
          <div class=" w-full items-center py-1 md:py-0 sm:py-0 md:pt-4 sm:pt-2 h-full px-2">
            <span className="font-roboto text-[#385a64]  md:text-lg text-base font-bold">
              {title}
            </span>
            <p className="font-roboto text-[#385a64] text-base text-center sm:text-sm font-normal">{content}</p>
          </div>
        </div>
      </div>
    
    </>
  );
};

export default box;
